import { useState } from 'react';
import classnames from 'classnames';

import { useTranslation } from '../../hooks/translation';
import { useAppStateContext } from '../../hooks/context';
import AppLink from '../AppLink';
import AppImage from '../AppImage';
// import AppText from '../AppText/AppText';
import AppTitle from '../AppTitle/AppTitle';

import styles from './AppAcordion.module.scss';

export default function AppAccordion({ title, subTitle, data }) {
  const { translate } = useTranslation();
  const { parameters } = useAppStateContext().context;

  const contact_link = parameters?.data?.find((x) => x.keyword === 'contact')?.value;

  const [selectedAccordion, setSelectedAccordion] = useState(null);

  const toogleAccordion = (index) => {
    if (selectedAccordion === index) return setSelectedAccordion(null);

    setSelectedAccordion(index);
  };

  return (
    <div className={styles.AppAccordion} itemScope itemType="https://schema.org/FAQPage">
      {/* <h1 className={styles.AppAccordion__Title}>{translate('faq')}</h1> */}
      <div className={styles.AppAccordion__Title}>
        <AppTitle>{title}</AppTitle>
        {subTitle && (
          <div className={styles.AppAccordion__Desc}>
            <h2>{subTitle}</h2>
          </div>
        )}
      </div>
      <ul className={styles.AppAccordion__List}>
        {data.map((item, index) => (
          <li
            className={styles.AppAccordion__ListItem}
            key={index}
            itemScope
            itemProp="mainEntity"
            itemType="https://schema.org/Question">
            <div
              className={classnames(styles.AppAccordion__Question, {
                [ styles[ 'AppAccordion__Question--Open' ] ]: selectedAccordion === index,
              })}
              onClick={() => toogleAccordion(index)}>
              <div className={styles.AppAccordion__Trigger}>
                <strong itemProp="name">{item.question}</strong>
                <ChevronDown />
              </div>
            </div>
            <div
              className="accordion_content"
              style={selectedAccordion === index ? { display: 'block' } : { display: 'none' }}
              itemScope
              itemProp="acceptedAnswer"
              itemType="https://schema.org/Answer">
              <div
                className={styles.AppAccordion__Answer}
                itemProp="text"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            </div>
          </li>
        ))}
      </ul>
      <div className={styles.AppAccordion__MoreInfo}>
        <figure className={styles.AppAccordion__Image}>
          <AppImage objectFit="contain" src={'/images/seemore.png'} />
        </figure>
        <div className={styles.AppAccordion__Texts}>
          <strong>{translate('faq_text')}</strong>
          <AppLink
            href={`/${contact_link}`}
            title={translate('faq_contact')}
            className={styles.AppAccordion__Link}>
            {translate('faq_contact')}
          </AppLink>
        </div>
      </div>
    </div>
  );
}

function ChevronDown() {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      stroke="currentColor"
      strokeWidth="2"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  );
}
